import React from 'react';
import { TextInput, NumberInput, LongTextInput, DatePicker, DropdownSelector, TimeSelector, CheckBox } from 'hyperdb-utils';
import CustomersSelector from '../../common/CustomersSelector';
import OriginSelector from '../../common/OriginSelector';
import moment from 'moment';

export default class Form extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeCustomer = this.handleChangeCustomer.bind(this);
    this.handleCustomerCreated = this.handleCustomerCreated.bind(this);
  }
  componentDidMount() {
    this.fetchProperties();
  }
  render() {
    const properties = this.props.api.getState('property').properties;
    const {arrival_date, departure_date} = this.props.objectData;
    const arrivalMaxDate = departure_date ?
      moment(departure_date).subtract(1, 'day')
      : undefined;
    const departureMinDate = arrival_date ?
      moment(arrival_date).add(1, 'day')
      : undefined;
    const openFrom = arrival_date && arrivalMaxDate ? (arrival_date < arrivalMaxDate ? arrival_date : arrivalMaxDate) : arrivalMaxDate || arrival_date;
    const openTo = departure_date && departureMinDate ? (departure_date > departureMinDate ? departure_date : departureMinDate) : departureMinDate || departure_date;
    const selectedProperty = properties && this.props.objectData.property.value[1]
      ? properties.find(p => p.id === this.props.objectData.property.value[1])
      : null;
    return (
      <div>
        <fieldset>
          <DatePicker
            label="Date *"
            name="creation_date"
            value={ this.props.objectData.creation_date }
            onChange={ this.handleChange.bind(this, 'creation_date') }
          />
          <OriginSelector
            required={ true }
            value={ this.props.objectData.origin }
            onChange={ this.handleChange.bind(this, 'origin') }
          />
          <DropdownSelector
            label="Property *"
            name="property"
            value={ this.props.objectData.property.value[1] || '' }
            options={ propertiesOptions(properties) }
            onChange={ this.handleChangeRelation.bind(this, 'property') }
          />
          {
            selectedProperty && selectedProperty.multi_unit === 2
              ? <DropdownSelector
                  label="Item"
                  name="item"
                  placeholder="--- set automatically ---"
                  value={ this.props.objectData.unit_id ? parseInt(this.props.objectData.unit_id) : null }
                  options={ unitsOptions(selectedProperty.units) }
                  onChange={ this.handleChange.bind(this, 'unit_id') }
                />
              : null
          }
          <CustomersSelector
            required={ true }
            customerId={ this.props.objectData.customer.value[1] }
            onChange={ this.handleChangeCustomer }
            onCustomerCreated={ this.handleCustomerCreated }
          />
        </fieldset>
        <fieldset>
          <DatePicker
            label="Arrival *"
            name="arrival_date"
            value={ this.props.objectData.arrival_date }
            maxValue={ arrivalMaxDate }
            openToDate={ openFrom }
            onChange={ this.handleChangeDate.bind(this, 'arrival_date') }
          />
        <DatePicker
            label="Departure *"
            name="departure_date"
            value={ this.props.objectData.departure_date }
            minValue={ departureMinDate }
            openToDate={ openTo }
            onChange={ this.handleChangeDate.bind(this, 'departure_date') }
          />
        </fieldset>
        <fieldset>
          <NumberInput
            label="Adults"
            name="nb_adults"
            value={ this.props.objectData.nb_adults }
            onChange={ this.handleChange.bind(this, 'nb_adults') }
          />
          <NumberInput
            label="Young adults"
            name="nb_young_adults"
            value={ this.props.objectData.nb_young_adults }
            onChange={ this.handleChange.bind(this, 'nb_young_adults') }
          />
          <NumberInput
            label="Children"
            name="nb_children"
            value={ this.props.objectData.nb_children }
            onChange={ this.handleChange.bind(this, 'nb_children') }
          />
          <NumberInput
            label="Young children"
            name="nb_young_children"
            value={ this.props.objectData.nb_young_children }
            onChange={ this.handleChange.bind(this, 'nb_young_children') }
          />
          <NumberInput
            label="Babies"
            name="nb_babies"
            value={ this.props.objectData.nb_babies }
            onChange={ this.handleChange.bind(this, 'nb_babies') }
          />
        </fieldset>
        <fieldset>
          <DropdownSelector
            label="Arrival transport"
            name="arrival_transport"
            value={ this.props.objectData.arrival_transport || '' }
            options={ this.transportsOptions() }
            onChange={ this.handleChange.bind(this, 'arrival_transport') }
          />
          <fieldset>
            <legend>Arrival time</legend>
            <TimeSelector
              label="Arrival time"
              name="arrival_time"
              value={ this.props.objectData.arrival_time }
              onChange={ this.handleChange.bind(this, 'arrival_time') }
            />
          </fieldset>
          <DropdownSelector
            label="Departure transport"
            name="departure_transport"
            value={ this.props.objectData.departure_transport || '' }
            options={ this.transportsOptions() }
            onChange={ this.handleChange.bind(this, 'departure_transport') }
          />
          <fieldset>
            <legend>Departure time</legend>
            <TimeSelector
              label="Departure time"
              name="departure_time"
              value={ this.props.objectData.departure_time }
              onChange={ this.handleChange.bind(this, 'departure_time') }
            />
          </fieldset>
          <CheckBox
            label="Must leave keys"
            name="leave_keys"
            checked={ this.props.objectData.leave_keys }
            onChange={ this.handleClickCheckbox.bind(this, 'leave_keys') }
          />
          <CheckBox
            label="Parking reserved"
            name="parking_reserved"
            checked={ this.props.objectData.parking_reserved }
            onChange={ this.handleClickCheckbox.bind(this, 'parking_reserved') }
          />
          <CheckBox
            label="Confirmation printed"
            name="confirmation_printed"
            checked={ this.props.objectData.confirmation_printed }
            onChange={ this.handleClickCheckbox.bind(this, 'confirmation_printed') }
          />
          <LongTextInput
            label="Remarks"
            name="remarks"
            value={ this.props.objectData.remarks }
            onChange={ this.handleChange.bind(this, 'remarks') }
          />
        </fieldset>
      </div>
    );
  }

  transportsOptions() {
    return ['plane', 'train', 'bus', 'taxi', 'car', 'motorbike', 'bicycle', 'foot'].map(t => {
      return { name: t, value: t };
    });
  }

  handleChange(attributeName, field) {
    let { name, value } = field;
    if (["arrival_time", "departure_time"].includes(attributeName)) {
      if (value === "Invalid date") value = null;
    }
    this.props.api.reservation.updateEditedObject({ attributeName, value });
  }
  handleChangeDate(attributeName, field) {
    const { name, value } = field;
    const date = value ? moment(value).format('YYYY-MM-DD') : null;
    this.handleChange(attributeName, { value: date });
  }
  handleChangeRelation(attributeName, field) {
    const { name, value } = field;
    const reference = { ...this.props.objectData[attributeName] };
    reference.value[1] = value;
    this.props.updateEditedObject({ attributeName, value: reference });
  }
  handleChangeCustomer(customerId) {
    this.handleChangeRelation('customer', { value: customerId });
  }
  handleCustomerCreated(customer) {
    this.handleChangeRelation('customer', { value: customer.id });
  }
  handleClickCheckbox(attributeName, field) {
    const value = !this.props.objectData[attributeName];
    this.props.api.reservation.updateEditedObject({ attributeName, value });
  }

  fetchProperties() {
    this.props.api.property.getObjects({
      queryOptions: [['id', 'name', 'multi_unit', 'units'], { order: { name: 'asc' } }],
    });
  }
  fetchCustomers() {
    this.props.api.customer.getObjects({
      queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
    });
  }
}

function propertiesOptions(properties) {
  if (!properties) return [];
  return properties.map(property => {
    return { name: property.name, value: property.id };
  });
}
function unitsOptions(units) {
  if (!units) return [];
  return units.map(unit => {
    return { name: unit.number, value: unit.number };
  });
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/reservation/components/Form.jsx